import { AdobeOptions, TrackingData, TrackingKey } from '../../common/utilities/analyticsUtility';

export function adobe(options: AdobeOptions) {
  if (!options.scriptSrc) {
    throw Error('Adobe Analytics scriptSrc is required');
  }

  // Embed Adobe Analytics Scripts
  const script = document.createElement('script');
  script.async = options.async !== undefined ? options.async : false;
  script.setAttribute('src', options.scriptSrc);
  script.setAttribute('type', 'text/javascript');

  // wait for adobe script to load then resolve the promise
  const promise = new Promise((resolve) => {
    script.onload = resolve;

    // add the script to the document head
    document.head.appendChild(script);
  });

  promise
    .then(waitForSatelliteTrackFn)
    .then(createBodyScript)
    .then(checkQueue); // make sure to dispatch any pending requests at this time.
  // return the dispatcher
  return adobeDispatcher;
}

export const waitForSatelliteTrackFn = () => {
  return new Promise<void>((resolve) => {
    const interval = window.setInterval(() => {
      if (window['_satellite'] && window['_satellite'].track) {
        window.clearInterval(interval);
        resolve();
      }
    }, 500);
  });
};

const createBodyScript = () => {
  // append script to end of body tag and run _satellite.pageBottom()
  const satelliteScript = document.createElement('script');
  satelliteScript.type = 'text/javascript';
  satelliteScript.innerHTML = '_satellite && _satellite.pageBottom();';
  document.body.appendChild(satelliteScript);
};

// store dispatch data into queue to use once
// adobe scripts are loaded
const queue: (TrackingData)[] = [];
const checkQueue = () => {
  if (queue.length === 0 || !window['_satellite'] || !window['_satellite'].track) {
    return;
  }

  // dispatch all items in queue
  queue.forEach(data => dispatch(data));

  // clear queue
  queue.length = 0;
};

const dispatch = (data: TrackingData) => {
  if (data) {
    if (data.detail.value !== undefined && data.type === TrackingKey.user) {
      window['_satellite'].track(data.type, data.detail.value);
    } else {
      window['_satellite'].track(data.type, data.detail);
    }
  }
};

// adobe analytics dispatcher
export function adobeDispatcher(data: TrackingData) {  
  if (!data || Object.keys(data).length < 2) {    
    console.error('[TrackingData] must be provided.');
  } else if (!data.type || !TrackingKey[data.type]) {    
    console.warn(`[${data.type}] tracking type is not valid.`);
  }
  // make sure satellite is available
  if (window['_satellite'] && window['_satellite'].track) {      
    checkQueue();
    dispatch(data);
  } else { 
    // add data to queue to process while the assets script is loading
    queue.push(data);
  }
}
